<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="店员姓名" prop="staffName">
                  {{form.staffName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="工号" prop="staffNo">
                  {{form.staffNo}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="入职时间" prop="joinTime">
                  {{formatDay(form.joinTime)}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="现在职门店" prop="shopName">
                  {{form.shopName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="现在职职位" prop="positionName">
                  {{form.positionName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="是否买股" prop="stockFlagCn">
                  {{form.stockFlagCn}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="晋升门店" prop="shopName">
                  {{form.shopName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="elevatePositionId" label="晋升职位" prop="elevatePositionId" :rules="$rules.changeIred">
                  <el-select v-model="form.elevatePositionId" clearable placeholder="请选择" @change="onStaffName" class="w100b">
                    <el-option v-for="item in staffList" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="applyAppointmentTime" label="上任时间" prop="applyAppointmentTime" :rules="$rules.changeIred">
                  <el-date-picker v-model="form.applyAppointmentTime" type="date" :picker-options="beginPickerOptions" placeholder="开始时间" class="w100b"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="el-form-item-update" ref="survey" label="工作概况" prop="survey" :rules="$rules.changeIred">
                  <el-input v-model="form.survey" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" maxlength="500" show-word-limit placeholder="现任职务及现任岗位工作情况简介"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="el-form-item-update" ref="reason" label="晋升理由" prop="reason" :rules="$rules.changeIred">
                  <el-input v-model="form.reason" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" maxlength="500" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="el-form-item-update" ref="reason" label-width="260px" label="征信报告截图（最多上传10张）" prop="creditImgList" :rules="$rules.changeIred">
                  <imgUpload @file="getFile" :limit="10" :fileList="form.creditImgList" @delete="handleDelete" module="elevateCredit"></imgUpload>
                </el-form-item>
              </el-col>
              
            </el-row>
          </el-form>
          <div class="drawer-footer pr24 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
export default {
  mixins: [minxin],
  components: {
    drawer,
    imgUpload
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "晋升申请",
      form: {
        staffName: '',
        staffNo: '',
        joinTime: '',
        stockFlag: '',
        elevateShopId: '',
        elevateShopName: '',
        elevatePositionId: '',
        elevatePositionName: '',
        applyAppointmentTime: '',
        survey: '',
        reason: '',
        creditImgList:[]
      },
      staffList: [{
        id: 101,
        value: "门店店长"
      }],
      userInfo: {
        shopBizConfig: {}
      }
    };
  },
  created() {
    this.init();
  },
  computed: {
		beginPickerOptions() {
			return {
				disabledDate(time) {
					return time.getTime() < new Date().getTime()-24*60*60*1000
				},
			}
		}
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data())
        this.addEditShow = true;
        if (Object.keys(org).length) {
          this.form = org;
        } else {
          this.$api.get(this.$url.companyStaff.currentStaff).then(res => {
            if (res) {
              let obj = {
                staffName: res.staffName,
                staffNo: res.staffNo,
                joinTime: res.joinTime,
                shopId: res.shopId,
                shopName: res.shopName,
                elevateShopId: res.shopId,
                elevateShopName: res.shopName,
                positionName: res.positionName,
                stockFlag: res.stockFlag,
                stockFlagCn: res.stockFlagCn || '',
                creditImgList: []
              }
              this.form = JSON.parse(JSON.stringify(obj))
              console.log(this.form);
            }
          });

          
        }
      });
    },
    getFile(res) {
      this.form.creditImgList.push(res.newImgUrl);
      console.log(this.form);
    },
    handleDelete(res) {
      this.form.creditImgList = res.myFileList;
    },
    onStaffName () {
      this.staffList.map(item => {
        if (item.id == this.form.elevatePositionId) this.form.elevatePositionName = item.value;
      })
    },
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.form.applyAppointmentTime = this.formatDay(this.form.applyAppointmentTime);
          if (!this.form.survey || this.form.survey < 20) {
            return this.$message.error("工作概况不能少于20字");
          } else if (!this.form.reason || this.form.reason < 20) {
            return this.$message.error("申请晋升的理由不能少于20字");
          }
          this.$api.post(this.$url.staffPositionElevate.apply, this.form).then(res => {
            if (res) {
              this.$api.success();
              this.addEditShow = false;
              this.$emit("change", true);
            }
          })
          // this.$api.post(this.$url.subsidyApply.save, this.form).then(res => {
          //   if (res) {
          //     this.$api.success();
          //     this.addEditShow = false;
          //     this.$emit("change", true);
          //   }
          // })
        }
      });
    },
    back () {
      this.addEditShow = false;
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.totalAmount {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin: 20px 0 0 0;
  .totalAmount_title {
    display: inline-block;
    width: 120px;
    min-width: 100px;
    padding-left: 24px;
    margin-right: 80px;
  }
}
</style>